export const repeat = <T>(item: T, times: number) => {
    let result: T[] = []
    for (let i = 0; i < times; i++) {
        result.push(item)
    }
    return result
}

export const getReturnItemsValue = (returnItems: any[]): number => {
    const itemsValue = returnItems.length > 1 
        ? returnItems.reduce((sum, f) => sum + f.orderItemPriceWithoutTax * 100, 0) / 100
        : returnItems[0].orderItemPriceWithoutTax

    // Making sure there are only 2 decimals otherwise we'll get DHL error
    return (itemsValue.toString().split(".")[1]?.length) > 2 ? Number(itemsValue.toFixed(2)) : itemsValue
}

export const mapState = (state: string): string => {
    let stateCode;
    switch (state) {
        case "Ontario":
            stateCode = "ON";
            break;
        case "Quebec":
            stateCode = "QC";
            break;
        case "Nova Scotia":
            stateCode = "NS";
            break;
        case "New Brunswick":
            stateCode = "NB";
            break;
        case "Manitoba":
            stateCode = "MB";
            break;
        case "British Columbia":
            stateCode = "BC";
            break;
        case "Prince Edward Island":
            stateCode = "PE";
            break;
        case "Saskatchewan":
            stateCode = "SK";
            break;
        case "Alberta":
            stateCode = "AB";
            break;
        case "Yukon":
            stateCode = "YT";
            break;
        case "Nunavut":
            stateCode = "NU";
            break;    
        case "Newfoundland":
            stateCode = "NL";
            break;     
        case "Northwest Territories":
            stateCode = "NT";
            break;
        default: 
            stateCode = state // if state doesn't exist in switch statement
            break;
    }
    return stateCode;
}
    